import script from "./LinkButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkButton.vue?vue&type=script&setup=true&lang=ts"

import "./LinkButton.vue?vue&type=style&index=0&id=06bfe72c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bfe72c"]])

export default __exports__